import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../API/apiClient';
import { decryptUserInfo } from '../../sharedFiles/decryption/Decryption';

export const loginUser = createAsyncThunk(
    'login/loginUser',
    async (credentials, { rejectWithValue }) => {
        try {
            const response = await apiClient.post('login', credentials);
            return response.data;
        } catch (error) {
            console.error('Login error:', error);
            return rejectWithValue(error.response?.data?.message || 'Invalid username or password'); // Return the error message
        }
    }
);
